import { createReducer } from '@reduxjs/toolkit'

import * as actions from '../actions'
import { IProfileState } from '../types'

const initialState: IProfileState['data'] = {
  user: null,
  userInfo: null,
  historyInfo: {
    history: [],
    page: 1,
    count: 0,
  },
}

export default createReducer(initialState, builder => {
  builder
    .addCase(actions.getProfileInfo.success, (state, action) => {
      state.user = action.payload || initialState.user
    })
    .addCase(actions.getUserInfo.success, (state, action) => {
      state.userInfo = action.payload || initialState.userInfo
    })
    .addCase(actions.getPayHistory.success, (state, action) => {
      state.historyInfo = action.payload
    })
})
